import { IGerarTokenFiservResponse, IKioskRepository } from "../../../domains/kiosk/interfaces/repositories/IKioskRepository";
import { IHttpRepository } from "../../interfaces/IHttpRepository";
import { ILocalStorageRepository } from "../../interfaces/ILocalStorageRepository";
import { IConfigRepository } from "../../interfaces/IConfigRepository";
import { ConfigTotemMeep, configTotemMeepToKiosk } from "./ConfigTotemMeep";
import { Kiosk } from "../../../domains/kiosk/aggregates/Kiosk";
import { HttpRepository } from "./_HttpRepository";
import { EventSessionStorage } from "../localStorage/EventSessionStorage";
import { LocalStorageRepository } from "../localStorage/_LocalStorageRepository";
import { CefSharpConfigRepository } from "../../services/cefSharpService/local/CefSharpConfigRepository";
import enviroment from "corss-cutting/enviroment";
import { ReactNativeConfigRepository } from "Infrastructure/services/reactNativeServices/ReactNativeConfigService";
import { isReactNative } from "utils/constants";
import { HostConfig, toHostConfig } from "../../services/cefSharpService/local/toHostConfig";

const keyStorage = "@kiosk";
export const keyBlockedCards = "@blockedCards";
const keyHostConfig = "@hostConfig";

export const KioskRepository = (
): IKioskRepository => {

  const httpRepository: IHttpRepository = HttpRepository();
  const localStorageRepository: ILocalStorageRepository = LocalStorageRepository();
  const eventSessionStorage = EventSessionStorage();

  let configRepository: IConfigRepository;
  if(isReactNative) {
    configRepository = ReactNativeConfigRepository();
  } else {
    configRepository = CefSharpConfigRepository();
  }
  const config: IConfigRepository = configRepository;

  // Windows: se a sincronizacao falhar (rede), o app segue vendendo com o kiosk guardado.
  // A casca precisa da ultima config conhecida mesmo assim (impressao e TEF).
  const pushCachedHostConfigAsync = async () => {
    if (!config.updateHostAsync) return;

    try {
      const cached = await localStorageRepository.get<HostConfig>(keyHostConfig);
      if (cached) {
        await config.updateHostAsync(cached);
      }
    } catch (error) {
      console.error("Não foi possível entregar a configuração guardada à casca.", error);
    }
  };

  const syncAsync = async () => {
    const configs = await config.getConfigAsync()
    await pushCachedHostConfigAsync();
    const reponseConfigMeep = await httpRepository.postAsync<any, ConfigTotemMeep>
      ("/UsuarioMeepPOS/AtualizarDadosEquipamento",
        {
          IMEI: configs.macAddress,
          // IMEI: '00215D299378',
          UsuarioMeepPOSId: configs.equipamentId,
          VersaoReactTotem: enviroment.appVersion,
          VersaoCefSharpTotem: configs.cefSharpVersion
        }
      )
    localStorageRepository.post(keyStorage, configTotemMeepToKiosk(reponseConfigMeep));
    try {
      // Windows: entrega à casca CefSharp os dados que os serviços C# (impressão, TEF) leem.
      if (config.updateHostAsync) {
        const hostConfig = toHostConfig(reponseConfigMeep);
        await localStorageRepository.post(keyHostConfig, hostConfig);
        await config.updateHostAsync(hostConfig);
      }
    } catch (error) {
      console.error("Não foi possível entregar a configuração à casca.", error);
    }
    httpRepository.getAsync<string[]>(`/Cartoes/Bloqueados?localId=${reponseConfigMeep.localId}`)
      .then((tags) => localStorageRepository.post(keyBlockedCards, tags))
      .catch(() => {});
    console.log("sync configKiosk", configs);
    const kiosk = configTotemMeepToKiosk(reponseConfigMeep);
    return {
      ...kiosk,
      token: configs.token,
      eventSessionId: await eventSessionStorage.getSessionIdAsync(
        kiosk.registroSessaoPOSId
      ),
    };
  };


  const getAsync = async (): Promise<Kiosk | null> => {
    let kioskValues: Kiosk | null = await localStorageRepository.get<Kiosk>(
      keyStorage
    );
    if (!kioskValues) {
      return null;
    }
    return {
      ...kioskValues,
      eventSessionId: await eventSessionStorage.getSessionIdAsync(
        kioskValues.registroSessaoPOSId
      ),
    };
  };



  const gerarTokenFiservAsync = async (): Promise<IGerarTokenFiservResponse> => {
    const response = await httpRepository.postAsync<undefined, IGerarTokenFiservResponse>(
      "UsuarioMeepPOS/GerarTokenFiserv",
      undefined
    );
    return response;
  };

  return { getAsync, syncAsync, gerarTokenFiservAsync };
};

